export type SuddenDeath = { active: boolean; secondsLeft: number; left: number; right: number; progress: number };

/** Identical tick-based danger boundaries for simulation, HUD and both renderers. */
export function suddenDeathState(
  bounds: { x: number; w: number },
  fightingTicks: number,
  limitSeconds: number,
  tickRate = 60,
): SuddenDeath | null {
  if (limitSeconds <= 0) return null;
  const secondsLeft = Math.max(0, Math.ceil(limitSeconds - fightingTicks / tickRate));
  const elapsed = Math.max(0, fightingTicks / tickRate - limitSeconds);
  const progress = Math.min(1, elapsed / 30);
  const inset = bounds.w * 0.5 * progress;
  return { active: fightingTicks >= limitSeconds * tickRate, secondsLeft, left: bounds.x + inset, right: bounds.x + bounds.w - inset, progress };
}
